import { OEPanelBaseModel } from "./oe-panel-base.model";
import { OENLockedState } from "../enums/oe-locked-state.enum";
import { BfxAutocompleteGenericModel } from "app/bfx-interface-controls/models/bfx-interface-controls.models";
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  SECS_MASK,
  SECS_DEFAULT,
  SECS_VALIDATE_TIME_PATTERN,
} from "../../interface/controls/bfx-time-input.component";
import { ICDNAuxMode } from "../../data-idc/enums/icd-aux-mode.enum";
import { ICTenorValueDateModel } from "../../interface/controls/models/bfx-interface-controls.models";
import { ICNInputControlState } from "../../interface/controls/models/bfx-interface-controls.enums";

export class OEPanelAlgoModel extends OEPanelBaseModel {
  /***************************************/
  /* FINANCIALS */

  public algoType: any = {
    label: "Type",
    labelKey: "order_entry.panel.label.order_type",
    dataset: [],
    disabled: false,
    value: null, // BfxAutocompleteGenericModel
    externalState: null, // BfxAutocompleteStateEnum
    lockState: OENLockedState.UNLOCKED,
  };

  public readonly orderType: any = {
    value: new BfxAutocompleteGenericModel(CubiqTS.RequestOrderType.ALGO, "ALGO"),
  };

  public limitPrice = {
    label: "Limit Price",
    labelKey: "order_entry.panel.label.limit_price",
    value: null,
    loadRate: false,
  };

  /* Value Date (autocomplete)*/
  public valueDate: {
    label: string;
    labelKey: string;
    value: ICTenorValueDateModel | null;
    isSpot: boolean;
    isBrokenDate: boolean;
    dataset: any;
    disabled: boolean;
    externalState: ICNInputControlState;
    state: ICNInputControlState;
    lockState: OENLockedState;
  } = {
    label: "Value date",
    labelKey: "order_entry.panel.label.value_date",
    value: new ICTenorValueDateModel(CubiqTS.Tenor.SPOT, null),
    isSpot: true,
    isBrokenDate: false,
    dataset: null,
    disabled: true,
    externalState: null,
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
  };

  constructor() {
    super();
    this.goodUntil.placeholder = "DAY";

    this.goodFrom.inputMask = this.goodUntil.inputMask = SECS_MASK;
    this.goodFrom.inputDefault = this.goodUntil.inputDefault = SECS_DEFAULT;
    this.goodFrom.inputPattern = this.goodUntil.inputPattern = SECS_VALIDATE_TIME_PATTERN;
    this.goodFrom.showSeconds = this.goodUntil.showSeconds = true;
  }
}
